import React from 'react';
import { HashLink as Link } from 'react-router-hash-link'

const BreadCrumb = ({ title, breadCrumb ,name }) => {
    return (
        <>
            <section className="page-title" 
              style={{ backgroundImage: `url(../images/background/${name})` }}

            >
                <div className="auto-container">
                    <h1>{title ? title : "Error Page"}</h1>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/home">Home</Link></li>
                        <li>{breadCrumb ? breadCrumb : "Error Page"}</li>
                    </ul>
                </div>
            </section >
        </>
    );
};

export default BreadCrumb;